import { replacePathParams } from '../http/replacePathParams';
import { type RequestBody } from '../http/type-helpers';

import {
  MFA_CREATE_CHALLENGE_ENDPOINT,
  MFA_DEVICES_ENDPOINT,
  MFA_STATUS_ENDPOINT,
  PRE_MFA_TOKEN_ENDPOINT,
} from '@/constants/endpoints';
import { typedHttp } from '@/modules/http';
import { type AxiosCompatibleResponse } from '@/modules/http/types';
import { type CreateMfaChallengeResponse } from '@/modules/mfa/aliases';

export function fetchMFAStatus(preMFAToken: string) {
  return typedHttp.get(MFA_STATUS_ENDPOINT, {
    headers: {
      Authorization: `Bearer ${preMFAToken}`,
    },
  });
}

export function fetchMfaDevices(preMfaToken: string) {
  return typedHttp.get(MFA_DEVICES_ENDPOINT, {
    headers: {
      Authorization: `Bearer ${preMfaToken}`,
    },
  });
}

export function addMfaDevice(
  preMfaToken: string,
  args: RequestBody<typeof MFA_DEVICES_ENDPOINT>
) {
  return typedHttp.post(MFA_DEVICES_ENDPOINT, args, {
    headers: {
      Authorization: `Bearer ${preMfaToken}`,
    },
  });
}

export function createMfaChallenge({
  preMfaToken,
  deviceId,
}: {
  preMfaToken?: string;
  deviceId: string;
}): Promise<AxiosCompatibleResponse<CreateMfaChallengeResponse>> {
  return typedHttp.post(
    replacePathParams(MFA_CREATE_CHALLENGE_ENDPOINT, { deviceId }),
    null,
    {
      headers: {
        Authorization: `Bearer ${preMfaToken}`,
      },
    }
  );
}

export function fetchPreMfaToken() {
  return typedHttp.get(PRE_MFA_TOKEN_ENDPOINT, { withAuth: true });
}
